<div  role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Team</h2>
      </div>
      <div class="modal-body">
        <form #userForm="ngForm">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                  <div class="col-md-2">
                    <div class="form-group">
                        <label for="titleId">Title</label>
                        <select name="titleId" id="titleId" class="form-control" ngModel>
                          <option *ngFor="let title of titles" value="{{title.id}}">{{title.name}}</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                        <label for="title">First Name</label>
                        <input class="form-control" name="fname" id="fname"  placeholder="First Name" ngModel required>
                      </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                        <label for="title">Last Name</label>
                        <input class="form-control" name="lname" id="lname"  placeholder="Last Name" ngModel required>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                        <label for="title">Email</label>
                        <input class="form-control" name="email" id="email"  placeholder="Email" ngModel required>
                      </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                        <label for="password">Password</label>
                        <input type="password" class="form-control" name="password" id="password"  placeholder="Password" ngModel required>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                      <label for="title">Telephone</label>
                      <input class="form-control" name="telephone" id="telephone"  placeholder="Telephone" ngModel required>
                    </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                      <label for="userTypeId">User Type</label>
                      <select name="userTypeId" id="userTypeId" ngModel #userTypeId class="form-control">
                          <option *ngFor="let userType of userTypes" value="{{userType.id}}">{{userType.name}}</option>
                      </select>
                    </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                        <label for="designationId">Designation</label>
                        <select name="designationId" id="designationId" ngModel class="form-control">
                            <option *ngFor="let designation of designations" value="{{designation.id}}">{{designation.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="userTypeId.value == 2">
                  <div class="form-group">
                    <label for="barristerId">Assigned Barrister </label>
                    <select name="barristerId" id="barristerId" ngModel class="form-control">
                      <option *ngFor="let barrister of barristers" value="{{barrister.id}}">{{barrister.fullname}}</option>
                    </select>
                </div>
                </div>
            </div>
              <div class="form-group">
                  <label for="notes">Notes</label>
                  <textarea class="form-control" name="notes" id="notes" rows="5" placeholder="Notes" ngModel></textarea>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="saveUser(userForm.value)" [disabled]="userForm.invalid">Save Team</button>
          <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>